/**
 * A chave da marca, extraída do caminho `/marcas/:marca/...`.
 *
 * 🔴 **Não existe marca padrão.** Antes desta demanda, cinco páginas faziam
 * `?? 'digiorgio'` — um palpite silencioso que, num grupo com duas marcas,
 * significa carregar os dados da marca errada sem que nada indique isso.
 *
 * O roteamento garante o segmento; se ele faltar, é defeito de rota, e a página
 * precisa dizer isso em vez de escolher por conta própria.
 */
export function marcaDaRota(): string | null {
  const chave = window.location.pathname.split('/')[2]
  return chave && chave.length > 0 ? chave : null
}
